import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'ufla-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    standalone: false,
})

export class ConfirmDialogComponent {
    data = inject<{
    message: string;
    title?: string;
    cancelMessage: string;
    confirmMessage: string;
    confirmColor: 'primary' | 'warn' | 'accent';
}>(MAT_DIALOG_DATA);
}
